/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
import React, { useState } from 'react'
import { useForm, Controller } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { WEBHOOK_NAME,WEBHOOK_URL,WEBHOOK_SECRET,WEBHOOK_SECRET_VALUE, WEBHOOK_NAME_ERROR, WEBHOOK_NAME_INVALID, ERR_INVALID_URL, WEBHOOK_SECRET_KEY_INVALID, WEBHOOK_SECRET_VALUE_INVALID, LABEL_BTN_CANCEL, VERSION_PAYLOADS } from 'src/constants/constant';
import { MenuItem, TextField } from '@mui/material';
import { addWebhookConfig } from 'src/services/webhookconfigService';
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
import { NotificationManager } from 'react-notifications';
import '../Styles/muiglobal.css';
import { useSelector } from 'react-redux';
import type { RootState, WebhookFormInputs, WebhookApiResponse } from '../types/types';


interface PropsType {
    closeModal: () => void;
    refreshPage: () => void;
}

const validationSchema = Yup.object().shape({
    WebhookName: Yup.string().required(WEBHOOK_NAME_ERROR).matches(/^\S.*\S$|^\S$/, WEBHOOK_NAME_INVALID),
    URL: Yup.string().required('Please enter the webhook URL').matches(
            /^((http|https):\/\/)?(www\.)?(?!.*(http|https|www\.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+(\/)?.([\w\?[a-zA-Z-_%\/@?]+)*([^\/\w\?[a-zA-Z0-9_-]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?(\?.*)?$/gm,
            ERR_INVALID_URL
        ),
    Version: Yup.string().required('Please select the webhook version'),
    SecretKey: Yup.string().matches(/^$|^\S(.*\S)?$/, WEBHOOK_SECRET_KEY_INVALID),
    SecretValue: Yup.string().matches(/^$|^\S(.*\S)?$/, WEBHOOK_SECRET_VALUE_INVALID),
});

function AddWebhookForm({closeModal, refreshPage}: PropsType): JSX.Element {
    const [isLoading, setIsLoading] = useState<boolean>(false)
    const { user } = useSelector((state: RootState) => state.auth);
    const [includeTestData, setIncludeTestData] = useState<boolean>(false);
    
    const {
        control,
        handleSubmit,
        formState: { errors },
        watch
    } = useForm<WebhookFormInputs>({
        resolver: yupResolver(validationSchema),
        mode: 'onSubmit',
    });

    const version = watch('Version');
    
    const onSubmit = async (data: WebhookFormInputs): Promise<void> => {
        data.CreatedBy =  user?.id ?? 0;
        data.ClientId = user?.clientId ?? 0;
        data.IncludeTestData = includeTestData;
        setIsLoading(true)
        await addWebhookConfig(data)
            .then(
                (res: WebhookApiResponse) => {
                    console.log(res)
                    if(res.status === 200) {
                        if(res.data.result === 1) {
                            
                            NotificationManager.success("Webhook added successfully")
                            refreshPage()
                        } else {
                            if(res.data.messages === "Unknown error has occurred ") {
                                
                                NotificationManager.error("Unknown error has occurred")
                            } 
                        } 
                    }
                }
            )
            .catch(
                error => {
                    console.log("error", error)
                    
                    NotificationManager.error("Unknown error has occurred")
                }
            )
            .finally(() => {
                console.log("done")
                setIsLoading(false)
            })
    }

    return (
        <React.Fragment>

            <form
                onSubmit={(e) => {
                    e.preventDefault();
                    void handleSubmit(onSubmit)(e);
                }}
            >
                <div className="relative px-[16px] pt-[10px]">
                    <div className="mb-[30px]">
                        <Controller
                            name="WebhookName"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                            <>
                                <TextField
                                {...field}
                                fullWidth
                                label="Webhook Name*"
                                autoComplete="off"
                                
                                error={!!errors.WebhookName} // Set error state based on form validation
                                placeholder={WEBHOOK_NAME}
                                />
                                {errors.WebhookName && (
                                <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                    {errors.WebhookName?.message} {/* Show the error message */}
                                </div>
                                )}
                            </>
                            )}
                        />
                    </div>

                    <div className="mb-[30px]">
                        <Controller
                            name="URL"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                            <>
                                <TextField
                                {...field}
                                fullWidth
                                label="Webhook URL*"
                                autoComplete="off"
                                error={!!errors.URL} // Set error state based on form validation
                                placeholder={WEBHOOK_URL}
                                />
                                {errors.URL && (
                                <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                    {errors.URL?.message} 
                                </div>
                                )}
                            </>
                            )}
                        />
                    </div>
                    <div className="mb-[30px]">
                        <Controller
                            name="SecretKey"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                            <>
                                <TextField
                                {...field}
                                fullWidth
                                label="Secret Key"
                                autoComplete="off"
                                
                                error={!!errors.SecretKey} // Set error state based on form validation
                                placeholder={WEBHOOK_SECRET}
                                />
                                {errors.SecretKey && (
                                <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                    {errors.SecretKey?.message} {/* Show the error message */}
                                </div>
                                )}
                            </>
                            )}
                        />
                    </div>
                    <div className="mb-[30px]">
                        <Controller
                            name="SecretValue"
                            control={control}
                            defaultValue=""
                            render={({ field }) => (
                            <>
                                <TextField
                                {...field}
                                fullWidth
                                label="Secret Value"
                                autoComplete="off"
                                
                                error={!!errors.SecretValue} // Set error state based on form validation
                                placeholder={WEBHOOK_SECRET_VALUE}
                                />
                                {errors.SecretValue && (
                                <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                    {errors.SecretValue?.message} {/* Show the error message */}
                                </div>
                                )}
                            </>
                            )}
                        />
                    </div>
                    <div className="mb-[30px]">
                        <Controller
                            name="Version"
                            control={control}
                            defaultValue="v1"
                            render={({ field }) => (
                            <>
                                <TextField
                                {...field}
                                select
                                fullWidth
                                label="Version*"
                                error={!!errors.Version}
                                >
                                    <MenuItem value="v1">v1</MenuItem>
                                    <MenuItem value="v2">v2</MenuItem>
                                </TextField>
                                {errors.Version && (
                                <div className="flex absolute text-primary ml-1 mt-1 mb-1 text-md font-normal">
                                    <img src="/assets/images/attention.svg" alt="name" width={12} height={12} className="mr-1"/>
                                    {errors.Version?.message}
                                </div>
                                )}
                            </>
                            )}
                        />
                    </div>
                    <div className="mb-[30px]">
                        <div className='flex items-center whitespace-nowrap'>
                            <input
                                type="checkbox"
                                id="includeTestDataCheckbox"
                                disabled={isLoading}
                                checked={includeTestData}
                                onChange={(e) => {
                                    setIncludeTestData(e.target.checked);
                                }}
                                className="mr-2 disabled:opacity-50 disabled:cursor-not-allowed"
                            />
                            <label
                                htmlFor="includeTestDataCheckbox"
                                className={`mr-1 font-medium text-14 ${
                                    isLoading
                                        ? 'text-[#9ca3af] cursor-not-allowed'
                                        : 'text-[#3a3a3a] cursor-pointer'
                                }`}
                            >
                                Include Test Data
                            </label>
                        </div>
                    </div>
                    {Boolean(version) && Boolean(VERSION_PAYLOADS[version]) && (
                        <div className="mb-[30px]">
                            <label className="block mb-1 text-14 font-medium text-[#3a3a3a]">
                                {version.toUpperCase()} Payload
                            </label>
                            <pre className="bg-[#1e1e2e] text-white rounded p-3 text-13 overflow-auto whitespace-pre-wrap">
                                {VERSION_PAYLOADS[version]}
                            </pre>
                        </div>
                    )}
                </div>
                <div className="grid grid-cols-6 gap-0 fixed bottom-0 w-[100%] z-10 bg-white">
                    <div className="w-full relative col-span-3">
                        <button type='button' className="btn btn-block bg-white font-semibold capitalize border-1 border-[#D9D9D9] rounded-none text-14 text-muted w-full hover:bg-[#ccc] hover:border-[#D9D9D9] disabled:bg-[#f0f0f0] disabled:text-muted" disabled={isLoading} onClick={closeModal}>{LABEL_BTN_CANCEL}</button>
                    </div>
                    <div className="w-full relative col-span-3">
                        <button type="submit" className="btn btn-block bg-gradient-to-b btn-primary from-[#ED4B52] to-[#D6242C] h-[45px] text-14 focus-visible:outline-none rounded-none font-semibold text-white disabled:btn-primary disabled:opacity-100 disabled:text-white capitalize hover:from-[#D6242C] hover:to-[#ED4B52]">{!isLoading ? 'Save' : <span className="loading loading-spinner loading-xs text-white"></span>}</button>
                    </div>
                </div>
            </form>


        </React.Fragment>
    )
}

export default AddWebhookForm